module.exports = __webpack_public_path__ + "static/React-icon-a4946b2254bc24a89b632678c62929c1.png";